module.exports = __webpack_public_path__ + "img/button_join.e341b446.png";